import styled from 'styled-components'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Container from 'react-bootstrap/Container'
import { MdArrowBack } from 'react-icons/md'
import { customMedia } from '~/styles/global'
import WhiteButton from '~/components/WhiteButton'

export const CustomContainer = styled(Container).attrs({
  className: 'animated fadeIn',
})``

export const CampaignRevisionContainer = styled.div`
  background-color: #ffffff;
  border-radius: 5px;
  padding: 0 20px 20px 20px;
  position: relative;
`

export const Title = styled.p`
  margin: 0px;
  color: #484848;
  font-family: Open Sans;
  font-size: 23px;
  font-weight: 700;
  line-height: 27px;
  padding: 20px 15px 0px 5px;
`

export const SpinnerContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
`

export const LoadingApproveFormatContainer = styled.div`
  position: fixed;
  top: 20%;
  left: 44%;
`

export const CustomSpinner = styled(Spinner).attrs({
  animation: 'border',
  size: 'sm',
})``

export const Subtitle = styled.p`
  margin: 0px;
  width: 66%;
  color: #635b5b;
  font-family: Lato;
  font-size: 15px;
  font-weight: 400;
  line-height: 15px;
  padding: 0px 15px 5px 15px;
`

export const PageContainer = styled.div`
  width: auto;
  background-color: #fff;
  border-radius: 10px;
  padding-bottom: 15px;
`

export const CommunityContainer = styled.div`
  display: flex;
  margin-left: 10px;
`

export const SponsorInformationsContainer = styled.div`
  padding: 35px 0px 20px 0px;
  display: flex;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-bottom-color: rgba(214, 214, 214, 0.3);
  border-bottom-style: solid;

  ${customMedia.lessThan('1430px')`
     flex-direction: column;
     justify-content: center;
     padding: 35px 0px 40px 0px;
  `}
`

export const SponsorInformations = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const SponsorLogo = styled.img`
  border-radius: 100px;
  width: 74px;
  height: 74px;
`

export const CommunityNameAndLocationSection = styled.div`
  margin-top: 6px;
  span {
    font-size: 18px;
    width: 100%;
  }
`

export const CommunityLocation = styled.p`
  margin: 0px;
  color: var(--text-primary);
  font-family: Lato;
  font-size: 14px;
  font-weight: 400;
  margin-top: -6px;
`

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  background-image: linear-gradient(to right, #9671f5 50%, #7345e9 100%);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  height: 55px;
  padding: 0 15px;
  width: 100% !important;
`

export const HeaderBackContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
`

export const HeaderRouteText = styled.p`
  margin: 0px;
  color: #fff;
  font-family: Roboto;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  margin-left: 10px;
`

export const HeaderBackText = styled.p`
  margin: 0px;
  color: #fff;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  margin-left: 6px;
`

export const HeaderVerticalLine = styled.p`
  margin: 0px;
  border-left: 2px solid #7345e9;
  height: 20px;
  margin-left: 18px;
`

export const CampaignContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const CampaignBudgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const CampaignInformationTitle = styled.p`
  margin: 0px;
  color: #635b5b;
  font-family: Lato;
  font-size: 15px;
  padding: 0px 15px 0px 15px;
`

export const CampaignInformations = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${customMedia.lessThan('1430px')`
     margin-top: 24px;
  `}
`

export const CampaignInformationSubtitle = styled.p`
  margin: 0px;
  color: #484848;
  font-family: Lato;
  font-size: min(1.4vw, 23px);
  font-weight: 700;
`

export const CampaignInformationYear = styled(CampaignInformationSubtitle)`
  font-size: min(1.4vw, 16px);
  position: absolute;
  bottom: 10px;

  ${customMedia.lessThan('1430px')`
     bottom: -20px;
  `}
`

export const SearchInputContainer = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;
  border-bottom-width: 1px;
  border-bottom-color: rgba(214, 214, 214, 0.3);
  border-bottom-style: solid;
  padding-bottom: 25px;

  ${customMedia.lessThan('1340px')`
     flex-direction: column;
  `}
`

export const ButtonContainer = styled.div`
  display: flex;
  margin-right: 10px;

  ${customMedia.lessThan('1340px')`
    display: flex;
    margin-top: 30px;
    justify-content: flex-end;
  `}
`

export const BodyContainer = styled.div`
  padding: 20px 10px;
`

export const ProductsTabContainer = styled.div`
  margin-top: 30px;
`

export const GridTitleContainer = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
`

export const RequestChangeButton = styled(WhiteButton).attrs({})``

export const ApproveButton = styled(WhiteButton).attrs({
  style: { padding: '0px 20px' },
  className: 'animated fadeIn',
})``

export const CheckboxColumn = styled(Col).attrs({
  md: 1,
})``

export const TypeColumn = styled(Col).attrs({
  md: 2,
})`
  display: flex;
  justify-content: center;
`

export const TitleColumn = styled(Col).attrs({
  md: 2,
})``

export const TimingColumn = styled(Col).attrs({
  md: 2,
})`
  display: flex;
  justify-content: center;
`

export const StatusColumn = styled(Col).attrs({
  md: 2,
})``

export const ActionsColumn = styled(Col).attrs({
  md: 3,
})`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const BackIcon = styled(MdArrowBack).attrs({
  size: 25,
  color: '#FFF',
})``

export const CampaignName = styled.div`
  margin-top: 2px;
  max-width: 200px;
  word-break: normal;
  color: var(--community-primary);
  font-family: Lato;
  font-size: 17px;
  font-weight: 700;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
`

export const CampaignNameLabel = styled.div`
  max-width: 200px;
  word-break: normal;
  color: #47525e;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
`

export const CompanyName = styled.p`
  margin: 0px;
  color: var(--sponsor-primary);
  font-family: Lato;
  font-size: 17px;
  font-weight: 600;
  letter-spacing: 0.5px;
  width: 12vw;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
`

export const CompanyNameLabel = styled.p`
  margin: 0px;
  margin-top: 6px;
  max-width: 200px;
  word-break: normal;
  color: #47525e;
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 18px;
`
